
import { Component, Vue, Prop } from "vue-property-decorator";
import { Notify } from "quasar";

@Component({
  components: {}
})
export default class RectComponent extends Vue {
  @Prop({ type: Object, required: true }) item!: Record<string, any>;

  get shouldShowHover(): boolean {
    return !!this.item.has_popup || !!this.item.link;
  }

  public openDialog() {
    if (this.item.has_popup) {
      this.$emit("open-dialog", this.item);
    } else {
      if (this.item.link) {
        window.open(this.item.link, this.item.target);
      }
    }
  }
}
